import { RouteObject } from 'react-router-dom'
import { default as Ordering } from '.'
import { PageLayout } from '$components/common'

const basePath = '/stock/ordering'
export const stockOrderingRoutes: RouteObject[] = [
  {
    path: `${basePath}/purchase-orders`,
    element: (
      <PageLayout title="Outstanding Orders" displayLeftTitle={false}>
        <Ordering.OutstandingOrders.Component />
      </PageLayout>
    ),
    loader: Ordering.OutstandingOrders.Loader,
  },
  {
    path: `${basePath}/predicted-order`,
    element: (
      <PageLayout title="Predicted Order" displayLeftTitle={false}>
        <Ordering.PredictedOrder.Component />
      </PageLayout>
    ),
    loader: Ordering.PredictedOrder.Loader,
  },
  {
    path: `${basePath}/order-history`,
    element: (
      <PageLayout title="Order History" displayLeftTitle={false}>
        <Ordering.OrderHistory.Component />
      </PageLayout>
    ),
    loader: Ordering.OrderHistory.Loader,
  },
  {
    path: `${basePath}/order-templates`,
    element: (
      <PageLayout title="Order Templates" displayLeftTitle={false}>
        <Ordering.OrderTemplates.Component />
      </PageLayout>
    ),
    loader: Ordering.OrderTemplates.Loader,
  },
  // Credit Request and Purchase Order share a similar structure, but they are stored
  // in separate database tables for compatibility reasons.
  // To reflect this, we provide two distinct routes/links even though both pages
  // live under the `purchase-orders/add` folder structure.
  {
    path: `${basePath}/order-templates/:templateId`,
    element: (
      <PageLayout title="Edit Order" displayLeftTitle={false}>
        <Ordering.EditOrderTemplate.Component />
      </PageLayout>
    ),
    loader: Ordering.EditOrderTemplate.Loader,
  },
  {
    path: `${basePath}/purchase-orders/purchase-order/add`,
    element: (
      <PageLayout title="New Purchase Order" displayLeftTitle={false}>
        <Ordering.AddPurchaseOrder.Component />
      </PageLayout>
    ),
    loader: Ordering.AddPurchaseOrder.Loader,
  },
  {
    path: `${basePath}/purchase-orders/credit-request/add`,
    element: (
      <PageLayout title="New Credit Request" displayLeftTitle={false}>
        <Ordering.AddCreditRequest.Component />
      </PageLayout>
    ),
    loader: Ordering.AddPurchaseOrder.Loader,
  },
  {
    path: `${basePath}/purchase-orders/:purchaseOrderId`,
    element: (
      <PageLayout>
        <Ordering.EditPurchaseOrder.Component />
      </PageLayout>
    ),
    loader: Ordering.EditPurchaseOrder.Loader,
  },
  {
    path: `${basePath}/supplier-tenders`,
    element: (
      <PageLayout title="Supplier Tenders" displayLeftTitle={false}>
        <Ordering.Tenders.Component />
      </PageLayout>
    ),
    loader: Ordering.Tenders.Loader,
  },
  {
    path: `${basePath}/supplier-tenders/create`,
    element: (
      <PageLayout title="New Tender" displayLeftTitle={false}>
        <Ordering.ManageTender.Component />
      </PageLayout>
    ),
    loader: Ordering.ManageTender.Loader,
  },
  {
    path: `${basePath}/supplier-tenders/:tenderId`,
    element: (
      <PageLayout title="Edit Tender" displayLeftTitle={false}>
        <Ordering.ManageTender.Component />
      </PageLayout>
    ),
    loader: Ordering.ManageTender.Loader,
  },
  {
    path: `${basePath}/supplier-tenders/:tenderId/review`,
    element: (
      <PageLayout title="Review Tender" displayLeftTitle={false}>
        <Ordering.ReviewTender.Component />
      </PageLayout>
    ),
    loader: Ordering.ReviewTender.Loader,
  },
]
